import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Drawer, IconButton, Divider, List } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {MdChevronLeft} from "react-icons/md";
import SidebarLink from "./SidebarLink/SidebarLink";
import { structureSuper } from '../IconosSuperAdmin'; // cargo el menu
import { structureIntegrador } from '../IconosIntegrador'; // cargo el menu
import { structureAdmin } from '../IconosAdmin'; // cargo el menu
import IsMobileContext from "context/isMobile/isMobileContext";
import AuthContext from "context/autentication/authContext";
import MenuSoporte from "./MenuSoporte/SoporteComponente"
import { Role } from "types/roles";
import { structureAltaUsuario } from 'layout/IconosAltaUsuario';

const drawerWidth = 210;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        overflowX: 'hidden',

        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),

    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        //para cambiar el ancho de la sidebar
        width: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(6),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    sidebarListMenu: {
        height:"90%"
    },
    sidebarListSoporte: {
        height:"10%",
        marginLeft:".3em",
    },
    support:{
        zIndex: theme.zIndex.drawer + 2,
    }
}));

const Sidebar = ({ location, open, handleDrawerOpen, handleDrawerClose }) => {
    const classes = useStyles();
    const isMobile = useContext(IsMobileContext);
    const { isMobileUse } = isMobile;
    //var theme = useTheme();
    const authContext = useContext(AuthContext);
    const { rol } = authContext;
    var [isPermanent, setPermanent] = useState(true);

    useEffect(function () {
        window.addEventListener("resize", handleWindowWidthChange);
        handleWindowWidthChange();
        return function cleanup() {
            window.removeEventListener("resize", handleWindowWidthChange);
        };
    });

    return (
        <>
        { !isMobileUse() ? <>

            {(rol === Role.Super) ?
                <Drawer variant={isPermanent ? "permanent" : "temporary"}
                    classes={{
                        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                    }}
                    open={open}
                >
                    <div className={classes.toolbarIcon}>
                        <IconButton onClick={handleDrawerClose}>
                            <MdChevronLeft />
                        </IconButton>
                    </div>
                    <Divider />
                    <List className={classes.sidebarListMenu}>
                        {structureSuper.map(link => (
                            <SidebarLink
                                key={link.id}
                                location={location}
                                //isSidebarOpened={isSidebarOpened}
                                {...link}
                            />
                        ))}
                    </List>
                    <List className={classes.sidebarListSoporte}>

                        {/* 
                            TODO: Terminar Soporte
                            <MenuSoporte className={classes.support} /> 
                        */}
                    </List>
                </Drawer>
                :
                (rol === Role.Integrador) ?
                    <Drawer variant={isPermanent ? "permanent" : "temporary"}
                        classes={{
                            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                        }}
                        open={open}
                    >
                        <div className={classes.toolbarIcon}>
                            <IconButton onClick={handleDrawerClose}>
                                <MdChevronLeft />
                            </IconButton>
                        </div>
                        <Divider />
                        <List className={classes.sidebarListMenu}>
                            {structureIntegrador.map(link => (
                                <SidebarLink
                                    key={link.id}
                                    location={location}
                                    children = {link.children }
                                    //isSidebarOpened={isSidebarOpened}
                                    {...link}
                                />
                            ))}

                        </List>
                        <List className={classes.sidebarListSoporte}>
                        {/* 
                        TODO: Terminar Soporte
                        <MenuSoporte className={classes.support} /> */}
                    </List>
                    </Drawer>
                    :
                    (rol === Role.Admin || rol===Role.Soporte) ?
                        <Drawer variant={isPermanent ? "permanent" : "temporary"}
                            classes={{
                                paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                            }}
                            open={open}
                        >
                            <div className={classes.toolbarIcon}>
                                <IconButton onClick={handleDrawerClose}>
                                    <MdChevronLeft />
                                </IconButton>
                            </div>
                            <Divider />
                            <List className={classes.sidebarListMenu}>
                                {structureAdmin.map(link => (
                                    <SidebarLink
                                        key={link.id}
                                        location={location}
                                        //isSidebarOpened={isSidebarOpened}
                                        {...link}
                                    />
                                ))}

                            </List>
                            <List className={classes.sidebarListSoporte}>
                        {/* 
                        TODO: Terminar Soporte
                        <MenuSoporte className={classes.support} /> */}
                        </List>
                        </Drawer>
                        :(rol === Role.AltaUsuario ) ?
                        <Drawer variant={isPermanent ? "permanent" : "temporary"}
                            classes={{
                                paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                            }}
                            open={open}
                        >
                            <div className={classes.toolbarIcon}>
                                <IconButton onClick={handleDrawerClose}>
                                    <MdChevronLeft />
                                </IconButton>
                            </div>
                            <Divider />
                            <List className={classes.sidebarListMenu}>
                                {structureAltaUsuario.map(link => (
                                    <SidebarLink
                                        key={link.id}
                                        location={location}
                                        //isSidebarOpened={isSidebarOpened}
                                        {...link}
                                    />
                                ))}

                            </List>
                            <List className={classes.sidebarListSoporte}>
                        </List>
                        </Drawer>
                        : null
            }
            </>
        : null}
        </>
    );
    // ##################################################################
    function handleWindowWidthChange() {
        var windowWidth = window.innerWidth;
        var breakpointWidth = 960;//theme.breakpoints.values.md;
        var isSmallScreen = windowWidth < breakpointWidth;
            if (isSmallScreen && isPermanent && !isMobileUse()) {
                setPermanent(false);
            } else if (!isSmallScreen && !isPermanent && !isMobileUse()) {
                setPermanent(true);
            }
    }
}



export default withRouter(Sidebar);